<template>
<el-input ref="nameField" :placeholder="originalPw" v-model="targetData.userPw">
</el-input></template>
<script>
import { isEmpty, isNil } from 'lodash';
import msgUtil from '@/utils/message';
import { PASSWORD_FOR_VIEW } from '@/constants/common';

export default {
  name: 'WUserPasswordBox',
  props: {
    targetData: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    passwordModify() {
      return isEmpty(this.targetData.userPw) ? null : this.targetData.userPw;
    },
    originalPw() {
      return isNil(this.targetData.beforePw) ? '' : PASSWORD_FOR_VIEW;
    },
  },
  watch: {
    passwordModify: {
      handler() {
        this.modiEnter();
      },
    },
  },
  methods: {
    // 수정 완료
    modiEnter() {
      this.onChangeCheckUserPw(this.targetData.userPw);
      this.$emit('check-change-flag');
    },
    onChangeCheckUserPw(userPw) {
      let pattern = /\s/g;
      if (pattern.test(userPw)) {
        this.$message(msgUtil.getCustomMsgData('비밀번호에 공백은 포함될 수 없습니다.'));
        this.targetData.userPw = '';
        this.$refs.nameField.clear();
        return false;
      }
      pattern = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/;
      if (pattern.test(userPw)) {
        this.$message(msgUtil.getCustomMsgData('비밀번호에 한글은 포함될 수 없습니다.'));
        this.targetData.userPw = '';
        this.$refs.nameField.clear();
        return false;
      }
      return true;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/netdevice/DeviceAccountSettings/AccountSynchronization/component/UserPasswordBox.vue